import React from "react";
import { createRoot } from "react-dom/client";
import Loyiha from "./Loyiha";

const root = createRoot(document.getElementById("root"));
root.render(<Loyiha />);
// npm install react-icons --save
// npm run build
